






import { Component, Prop, Vue } from "vue-property-decorator";
import { ppdsText } from "@/utils/ppdsCaption";

@Component
export default class PpdsCaption extends Vue {
  @Prop({ type: Object, default: null }) readonly person!: {
    ppds?: string | null;
  } | null;

  @Prop({ type: String, default: null }) readonly text!: string | null;

  get teks(): string | null {
    return ppdsText({ ppds: this.text }) || ppdsText(this.person);
  }
}
